export const getFieldValue = (instance: Object, fieldName: string | number | symbol) => {
  if(typeof fieldName === 'string' && fieldName.includes('.')) {
    const topField = (fieldName).split('.')[0];

    return getFieldValue(instance[topField], fieldName.replace(`${topField}.`, ''));
  }
  return instance?.[fieldName];
};